import { formatPrice } from 'utils/price';
import { OrderFragmentFragment as Order } from 'data/__generated__';
import { roundPrice } from 'utils/orders';

export interface DiscountResult {
    discountPrice: number;
    formattedDiscountPrice?: string;
    formattedDiscountEffect?: string;
    discountDescription?: string;
}

export function getDiscountFromOrder({ order, totalHT }: { order: Order; totalHT: number }): DiscountResult {
    if (order?.discount) {
        if (order.discount.type === 'Percentage') {
            return {
                discountPrice: roundPrice(totalHT * order.discount.amount),
                formattedDiscountPrice: formatPrice(-totalHT * order.discount.amount),
                formattedDiscountEffect: `(-${order.discount.amount * 100}%)`,
                discountDescription: order.discount.description,
            };
        }
        if (order.discount.type === 'Fixed') {
            const discountTotalValue = order.discount.amount > totalHT ? totalHT : order.discount.amount;
            return {
                discountPrice: discountTotalValue,
                formattedDiscountPrice: formatPrice(-discountTotalValue),
                formattedDiscountEffect: `(-${order.discount.amount}€)`,
                discountDescription: order.discount.description,
            };
        }
    }
    return { discountPrice: 0 };
}
